interface ChatBubbleProps {
    message: string;
    type: 'sent' | 'received' | 'ignore';
    onClick?: (() => void) | undefined;
}

function ChatBubble(props: ChatBubbleProps) {
    const { message, type, onClick } = props;

    return (
        <div
            className={`chat-bubble chat-bubble--${type}${onClick ? ' chat-bubble--clickable' : ''}`}
            onClick={onClick}
        >
            {message}
        </div>
    );
}

export default ChatBubble;
